import React, { useContext } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TextField, Switch, Autocomplete } from '@mui/material';
import axios from "axios"
import { Box } from '@mui/system';
import { AuthContext } from '../authContext/AuthContext';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const AddItem = ({addDialog, handleClose, items = []}) => {
  const [itemKey,setItemKey] = React.useState("");
  const [itemName,setItemName] = React.useState("");
  const [displayName,setDisplayName] = React.useState("");
  const [itemMainCategory,setItemMainCategory] = React.useState("");
  const [itemSubCategory,setItemSubCategory] = React.useState("");
  const [itemSubsubCategory,setItemSubsubCategory] = React.useState("");
  const [stock,setStock] = React.useState(0);
  const [itemClass,setItemClass] = React.useState("Class A");
  const [sellingPriceExclTax,setSellingPriceExclTax] = React.useState(0.00);
  const [sellingPriceInclTax,setSellingPriceInclTax] = React.useState(0.00);
  const [sgst,setSgst] = React.useState(2.5);
  const [cgst,setCgst] = React.useState(2.5);
  const [igst,setIgst] = React.useState(0.0);
  const [unitOfMeasurement, setUnitOfMeasurement] = React.useState("Kilograms");
  const [disabled, setDisabled] = React.useState(true);
  const [isActive, setIsActive] = React.useState(true);
  const { user, shop } = useContext(AuthContext)

  const mainCategories = [...new Set(items.map(item => item.itemMainCategory).filter(Boolean))];
  const subCategories = [...new Set(items.map(item => item.itemSubCategory).filter(Boolean))];
  const subSubCategories = [...new Set(items.map(item => item.itemSubsubCategory).filter(Boolean))];

  const resetField = async() => {
    setItemName("")
    setDisplayName("")
    setItemMainCategory("")
    setItemSubCategory("")
    setItemSubsubCategory("")
    setStock(0)
    setItemClass("Class A")
    setSellingPriceExclTax(0.00)
    setSellingPriceInclTax(0.00)
    setSgst(2.5)
    setCgst(2.5)
    setIgst(0.0)
    setUnitOfMeasurement("Kilograms")
    setDisabled(true)
    setIsActive(true)
  }
  const getItemKey = async(user) => {
    try {
      const res = await axios.get("/counter/itemkey", {headers: {token:"Bearer " + user.token}})
      setItemKey(res.data.sequenceValue)
    } catch (err) {
      console.log(err)
    }
  };      
  React.useEffect(() => {
    getItemKey(user);
  },[user]);
  React.useEffect(() => {
    const validate = async() => {
      setDisabled(itemName.trim().length === 0 
      || itemMainCategory.trim().length === 0)
    };
    validate();
  },[itemName, displayName, itemMainCategory, itemSubCategory, itemSubsubCategory]);
  const saveItem = async() => {
    try {
      const item = {itemKey, itemName, displayName, itemMainCategory, itemSubCategory, itemSubsubCategory, stock, itemClass, sellingPriceExclTax, sellingPriceInclTax, sgst, cgst, igst, unitOfMeasurement, active: isActive}
      await axios.post("/items", item, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
      await axios.put("/counter/itemkey", {}, {headers: {token:"Bearer " + user.token}})
      getItemKey(user);
      handleClose();
      resetField();
    } catch (err) {
      console.log(err)
    }
  };
  const min = 0;
  const max = 100;
  const sellingPriceInclTaxChange = async(event) => {
    let value = event.target.value === "" ? 0 : parseFloat(event.target.value);
    if (value < min) value = min;
    setSellingPriceInclTax(value);
    const per = 100 + cgst + sgst + igst;
    const res = (value*100)/per
    setSellingPriceExclTax(res.toFixed(2));
  }
  const cgstChange = async(event) => {
    let value = event.target.value === "" ? 0 : parseFloat(event.target.value);
    if (value > max) value = max;
    if (value < min) value = min;
    setCgst(value);
    const per = 100 + value + sgst + igst;
    const res = (sellingPriceInclTax*100)/per
    setSellingPriceExclTax(res.toFixed(2));
  }
  const sgstChange = async(event) => {
    let value = event.target.value === "" ? 0 : parseFloat(event.target.value);
    if (value > max) value = max;
    if (value < min) value = min;
    setSgst(value);
    const per = 100 + cgst + value + igst;
    const res = (sellingPriceInclTax*100)/per
    setSellingPriceExclTax(res.toFixed(2));
  }
  const igstChange = async(event) => {
    let value = event.target.value === "" ? 0 : parseFloat(event.target.value);
    if (value > max) value = max;
    if (value < min) value = min;
    setIgst(value);
    const per = 100 + cgst + sgst + value;
    const res = (sellingPriceInclTax*100)/per
    setSellingPriceExclTax(res.toFixed(2));
  }
  const handleCloseDialog = async() => {
    handleClose();
    resetField();
  };
  const handleUnitOfMeasurementChange = (event) => {
    setUnitOfMeasurement(event.target.value);
  };
  const handleItemClassChange = (event) => {
    setItemClass(event.target.value);
  };
  return (
    <div>
      <Dialog open={addDialog} onClose={handleCloseDialog} TransitionComponent={Transition} sx={{width: "100vw"}}>
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleCloseDialog} aria-label="close"><CloseIcon /></IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">Add Item</Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{margin: "2vh"}}>
          <Grid container spacing={2}>
              <Grid item xs={12}><TextField label="Item Key" variant="standard" fullWidth disabled value={itemKey}/></Grid>
              <Grid item xs={12}><TextField label="Item Name" variant="standard" fullWidth value={itemName} onChange={(event)=> setItemName(event.target.value)}/></Grid>
              <Grid item xs={12}><TextField label="Display Name" variant="standard" fullWidth value={displayName} onChange={(event)=> setDisplayName(event.target.value)}/></Grid>
              <Grid item xs={12}>
                <TextField select label="Item Class" value={itemClass} onChange={handleItemClassChange} variant="standard" SelectProps={{native: true}} fullWidth>
                  <option key="Class A" value="Class A">Class A</option>
                  <option key="Class B" value="Class B">Class B</option>
                  <option key="Class C" value="Class C">Class C</option>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={mainCategories}
                  value={itemMainCategory || null}
                  onChange={(event, newValue) => setItemMainCategory(newValue || "")}
                  onInputChange={(event, newInputValue) => setItemMainCategory(newInputValue || "")}
                  renderInput={(params) => <TextField {...params} label="Main Category" variant="standard" fullWidth />}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={subCategories}
                  value={itemSubCategory || null}
                  onChange={(event, newValue) => setItemSubCategory(newValue || "")}
                  onInputChange={(event, newInputValue) => setItemSubCategory(newInputValue || "")}
                  renderInput={(params) => <TextField {...params} label="Sub Category" variant="standard" fullWidth />}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={subSubCategories}
                  value={itemSubsubCategory || null}
                  onChange={(event, newValue) => setItemSubsubCategory(newValue || "")}
                  onInputChange={(event, newInputValue) => setItemSubsubCategory(newInputValue || "")}
                  renderInput={(params) => <TextField {...params} label="Sub Sub Category" variant="standard" fullWidth />}
                />
              </Grid>
              <Grid item xs={3}><TextField label="SP Incl Tax" type="number" variant="standard" fullWidth value={sellingPriceInclTax} onChange={(event)=> sellingPriceInclTaxChange(event)}/></Grid>
              <Grid item xs={2}><TextField label="CGST" type="number" variant="standard" fullWidth value={cgst} onChange={(event)=> cgstChange(event)}/></Grid>
              <Grid item xs={2}><TextField label="SGST" type="number" variant="standard" fullWidth value={sgst} onChange={(event)=> sgstChange(event)}/></Grid>
              <Grid item xs={2}><TextField label="IGST" type="number" variant="standard" fullWidth value={igst} onChange={(event)=> igstChange(event)}/></Grid>
              <Grid item xs={3}><TextField label="SP Excl Tax" type="number" variant="standard" fullWidth value={sellingPriceExclTax} disabled/></Grid>
              <Grid item xs={5}><TextField label="Stock" type="number" variant="standard" fullWidth value={stock} onChange={(event)=> setStock(event.target.value)}/></Grid>
              <Grid item xs={5}>
                <TextField select label="Unit Type" value={unitOfMeasurement} onChange={handleUnitOfMeasurementChange} variant="standard" SelectProps={{native: true}} fullWidth>
                  <option key="Kilograms" value="Kilograms">Kilograms</option>
                  <option key="Box" value="Box">Box</option>
                  <option key="Pieces" value="Pieces">Pieces</option>
                  <option key="Packet" value="Packet">Packet</option>
                  <option key="Cup" value="Cup">Cup</option>
                </TextField>
              </Grid>
              <Grid item xs={2}>
                <FormGroup>
                  <FormControlLabel control={<Switch checked={isActive} onChange={()=> setIsActive(!isActive)}/>} label="Active" />
                </FormGroup>
              </Grid>
              <Grid item xs={12}>
                <Button autoFocus variant="contained" onClick={saveItem} disabled={disabled} fullWidth>
                save
                </Button>
              </Grid>
          </Grid>
        </Box>
      </Dialog>
    </div>
  )
}

export default AddItem
